<div>
  <mat-card class="cookie-container">
    <!--! Title -->
    <div class="cookie-title">
      <ddc-text-gradient
        class="dashboard-header-txt dashboard-title text-2xl"
        [_text]="'Cookie Policy'"
        [_type]="'1'"
      ></ddc-text-gradient>
    </div>
    <div class="agreement-container text-sm">
      <div style="color: gray" [innerHTML]="'Last Update: ' + _lastUpdate"></div>
      <div [innerHTML]="_text"></div>
    </div>
  </mat-card>
</div>
